import React from 'react';
import { ArrowRight, Calendar, Mail, Shield, Lock, Server } from 'lucide-react';
import './Hero.css';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero-section" id="home">
      <div className="hero-background">
        <img 
          src="https://adityarathoreworld.in/cdn/bg-img.jpg" 
          alt="Hero Section background" 
          className="hero-image"
          width="100vw"
          height="100%"
        />
        <div className="hero-overlay"></div>
        <div className="hero-code-layer">
          <pre className="hero-code-snippet">{`<html>
  <body>
    <section class="agency-hero">
      <h1>WhiteLabelDevs</h1>
      <div class="stack">
        <li>Laravel</li>
        <li>PHP</li>
        <li>Cloud</li>
      </div>
    </section>
  </body>
</html>`}</pre>
        </div>
      </div>
      
      <div className="hero-content">
        <div className="hero-badge">
          <span>Secure Infrastructure • White-Label Ready • NDA Protected</span>
        </div>
        
        <h1 className="hero-title">
          White-Label Developers & Cloud Partners for Agencies
        </h1>
        
        <p className="hero-subtitle">
          We build, host, scale, and support secure AI + Laravel-powered applications with white-label development, managed cloud hosting, and growth-focused add-ons.
        </p>
        
        <p className="hero-clarity-line">
          Build. Host. Scale. Support. Everything your agency needs, under one roof.
        </p>
        
        <p className="hero-location">
          Based in India, available for local in-person meetings and remote partnerships.
        </p>
        
        <div className="hero-trust-indicators">
          <div className="trust-indicator">
            <Shield size={20} />
            <span>Secure Infrastructure</span>
          </div>
          <div className="trust-indicator">
            <Lock size={20} />
            <span>NDA Protected</span>
          </div>
          <div className="trust-indicator">
            <Server size={20} />
            <span>Hosting + Development</span>
          </div>
        </div>
        
        <div className="hero-cta">
          <button className="btn-primary" onClick={scrollToContact}>
            <Calendar size={20} />
            Book a Free Discussion
          </button>
          <button className="btn-secondary" onClick={scrollToContact}>
            <Mail size={20} />
            Get a Free Estimate
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;